export default "__VITE_ASSET__BghUL84j__"